// extracted by mini-css-extract-plugin
export default {"listProjects":"request-details_listProjects__1+NVr"};